import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import ServiceGuidance from "components/ServiceGuidance";
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";

import bgFront8 from "assets/images/poze-site/12-8-trat-pard.webp";
import bgBack8 from "assets/images/servicii/bgBack8.webp";

const advantages = {
    paragraphs: [
        "Doral Cleaning vă oferă servicii complete de curățenie. În timpul efectuării curățeniei generale sau postconstructor poate începe concomitent și pregătirea pardoselilor în vederea aplicării tratamentelor specifice.",
        "Astfel, eliminați grija și disconfortul generate de intervențiile neprofesionale, în care lucrările de pregătire și sigilare sunt realizate fără control asupra curățeniei, iar murdăria este răspândită în alte zone. Prin serviciile noastre integrate, nu mai este necesară apelarea ulterioară la o firmă separată pentru curățenie și igienizare, acestea fiind incluse în procesul complet de lucru.",
    ],
};

const advice = {
    paragraphs: [
        "Nu amânați sigilarea sau impermeabilizarea pardoselilor. Aceste operațiuni implică un cost redus în comparație cu cheltuielile generate de reparații sau înlocuirea plăcilor afectate de pete de uleiuri, grăsimi, băuturi colorate, vin roșu sau alte substanțe cu caracter ușor acid sau alcalin.",
        "Evitați colaborarea cu persoane neautorizate sau cu firme care nu pot garanta calitatea serviciilor și care nu își pot asuma răspunderea legală pentru eventualele deteriorări cauzate de neatenție sau lipsă de experiență.",
        "Solicitați informații detaliate despre metodele de lucru și produsele utilizate, verificați corectitudinea acestora și asigurați-vă că sunt respectate în mod corespunzător pe durata execuției.",
        "Recomandăm efectuarea unei probe de lucru într-o zonă mai puțin vizibilă. Chiar dacă această etapă implică un cost suplimentar, veți avea certitudinea că serviciul prestat corespunde așteptărilor și oferă rezultatele dorite.",
    ],
};

function InformationHome() {
    return (
        <MKBox component="section" py={6} my={6}>
            <Container>
                <Grid container spacing={4} alignItems="stretch">
                    <Grid item xs={12} lg={4}>
                        <RotatingCard>
                            <RotatingCardFront
                                image={bgFront8}
                                icon="touch_app"
                                title="Tratamente pardoseli"
                                description="Protecție, restaurare și finisare profesională pentru fiecare material."
                            />
                            <RotatingCardBack
                                image={bgBack8}
                                title="Proces complet"
                                description="Solicită o evaluare gratuită."
                                action={{
                                    type: "internal",
                                    route: "/contact-curatenie",
                                    label: "cere o ofertă",
                                }}
                            />
                        </RotatingCard>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                        <ServiceGuidance advantages={advantages} advice={advice} />
                    </Grid>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default InformationHome;
